module.exports = __webpack_public_path__ + "04_bob_brown.86792a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_bob_brown.png
// module id = PgWp
// module chunks = 0